import personLogo from "../assets/svgs/profile-16-logo.svg";
export const personData = {
  personLogo: personLogo,
  clientName: "John Doe",
  mobileNumber: "+1 234 567 890",
  policyNumber: "AB123456789",
  dueDate: "2024-09-15",
};
